import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ButtonColor } from "../../../../components/button/button.constants";
import { simpleDateFromTimestamp } from "../../../../helpers/date";
import { AppConfig } from "../../../../appConfig";
import PlaceholderImg from '../../../../images/defaultPlaceholder.jpg';
import { isFullUrl } from '../../../../utils';
import { ListDesktopDownloadButton, ListDesktopDownloadIcon } from "../filesToDownload/filesToDownload.styled";
import { getUriType } from "../passHistory/passHistory.utils";
import { downloadByFileType } from "../../../../api/requests";

import {
  Container,
  Cell,
  Thumbnail,
  Title,
  TimeIcon,
  Time,
} from "./passItemDesktop.styled";

export const PassItemDesktop = ({
  id,
  title,
  imageSrc,
  minutes,
  type,
  passTimestamp,
}) => {
  const { t } = useTranslation();
  const date = simpleDateFromTimestamp(passTimestamp);
  const uriType = getUriType(type.type);
  const [currentImg, setCurrentImg] = useState(() => isFullUrl(imageSrc) ? imageSrc : `${AppConfig.content}${imageSrc}`);

  const handleDownload = () => {
    downloadByFileType(uriType, id);
  };

  return (
    <Container>
      <Cell>
        <Thumbnail onError={() => setCurrentImg(PlaceholderImg)} src={currentImg} />
        <Title>{title}</Title>
      </Cell>
      <Cell>
        <TimeIcon />
        <Time>{minutes} {t("idd.passItemDesktop.minutes")}</Time>
      </Cell>
      <Cell>{type.label}</Cell>
      <Cell>{date}</Cell>
      <Cell>
        <ListDesktopDownloadButton
          color={ButtonColor.Primary}
          onClick={handleDownload}
          disabled={!uriType}
        >
          {t("idd.passItemDesktop.download")}
          <ListDesktopDownloadIcon />
        </ListDesktopDownloadButton>
      </Cell>
    </Container>
  );
};
